/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";

export default class PrimaryButton extends BaseCom {
    render() {
        let className = 'btn btn-primary';
        if(this.props.lg) className += ' btn-lg';
        if(this.props.block) className += ' d-block';
        return (
            <button
                className={className}
                type={this.props.submit ? 'submit' : 'button'}
                onClick={this.props.onClick}
                disabled={this.props.disabled}>
                    <span>{this.props.icon} {this.props.children || this.props.label}</span>
            </button>
        );
    }
}